module.exports = __webpack_public_path__ + "img/driver_profile_photo.20e4e98a.jpg";